export default __webpack_public_path__ + "static/cortina-italy-132a6c8e524040c73b92d2d02ea335dc.jpg";